var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcoustics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.8,37.3h3.3c0.4,0,0.7-0.3,0.7-0.7l0,0V8.3c0-0.4-0.3-0.7-0.7-0.7c0,0,0,0,0,0h-3.3 c-0.3,0.1-0.6,0.3-0.6,0.7v2.1l-4.4,1.5c-1.9,0.6-3.3,2.3-3.5,4.3h-2v-1.3c0-0.4-0.3-0.7-0.7-0.7H6c-0.4,0-0.7,0.3-0.7,0.7v1 l-2.4,2.5c-0.1,0.1-0.2,0.2-0.2,0.4v7.9c0,0.2,0.1,0.4,0.2,0.5l2.4,2.5v1c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0h4.6 c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0v-1.3h2c0.2,2,1.6,3.7,3.5,4.3l4.4,1.4v1.5C21.2,37,21.5,37.3,21.8,37.3z M10,30H6.7V15.5H10V30z  M17.3,32.4c-1.6-0.5-2.7-2-2.7-3.7V16.8c0.1-1.7,1.1-3.1,2.7-3.7l3.9-1.3v22L17.3,32.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.7,
    y: 15.5,
    fill: "#C9C9C9",
    width: 3.3,
    height: 14.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M21.2,11.8l-3.9,1.3c-1.6,0.6-2.6,2-2.7,3.7v11.9c0,1.7,1.1,3.2,2.7,3.7l3.9,1.4V11.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.3,24.8c1-1,1.1-2.6,0.1-3.7c0,0-0.1-0.1-0.1-0.1l-0.9,1c0.5,0.5,0.5,1.3,0,1.8L28.3,24.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.7,26.1l1,0.9c2.3-2.3,2.3-6.1,0-8.4l-1,0.9C31.5,21.4,31.5,24.3,29.7,26.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M33,16.2l-0.9,1c3,3.1,3,8.1,0,11.2l0.9,0.9c1.7-1.7,2.7-4.1,2.7-6.5C35.7,20.4,34.7,18,33,16.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M35.3,13.9l-0.9,0.9c2.1,2.1,3.3,5,3.3,8c0,3-1.2,5.8-3.3,7.9l0.9,1C40.2,26.8,40.2,18.9,35.3,13.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.7,11.6l-1,0.9C39.5,15.3,41,19,41,22.9c0,3.9-1.5,7.6-4.3,10.3l1,0.9c2.9-3,4.6-7,4.6-11.2 C42.3,18.7,40.6,14.6,37.7,11.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcoustics);
export default __webpack_public_path__ + "static/media/acoustics.c70073f771614f991a79e135896dbb05.svg";
export { ForwardRef as ReactComponent };